module.exports = {
      id: "error-usage",
      viewBox: "0 0 15.7 14",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#error-usage",
      toString: function () {
        return this.url;
      }
    }